import { render } from "./smallcard.vue?vue&type=template&id=34407f4d"
import script from "./smallcard.vue?vue&type=script&lang=js"
export * from "./smallcard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__